import { type SeparatorProps, useSeparator } from "react-aria"
import { twMerge } from "tailwind-merge"

type DividerProps = {
  className?: string
  variant?: "primary" | "secondary"
  orientation?: SeparatorProps["orientation"]
}

/**
 * A visual separator that divides content.
 *
 * ```tsx
 * import { Divider } from "@tokenterminal/core/ui/layout/divider/Divider"
 *
 * <Divider />
 * ```
 */

export function Divider({
  className,
  orientation = "horizontal",
  variant = "primary",
}: DividerProps) {
  const { separatorProps } = useSeparator({ orientation })

  return (
    <div
      {...separatorProps}
      aria-hidden="true"
      data-orientation={orientation}
      data-variant={variant}
      className={twMerge(
        "data-[orientation=horizontal]:h-px bg-border-default data-[orientation=vertical]:h-auto data-[orientation=vertical]:self-stretch data-[orientation=vertical]:w-px data-[variant=secondary]:bg-(--border-secondary)",
        className
      )}
    />
  )
}
